import { gql } from '@apollo/client';

export const SEND_REFERRAL_TO_FRIENDS = gql`
  mutation SendReferralToFriends($input: SendReferralToFriends!) {
    sendReferralToFriends(input: $input)
  }
`;